import classNames from "classnames";
import type { ResponsiveSizeClass } from "projects/wire/responsive-size-classes";
import { defaultResponsivePrefix } from "projects/wire/responsive-size-classes";
import * as React from "react";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";

export const ResponsiveProvider: React.FC<{
    id: string;
    className?: string;
    prefix?: string;
    maxSize?: ResponsiveSizeClass;
}> = p => {
    const { prefix = defaultResponsivePrefix, maxSize = "2xl" } = p;
    return (
        <ReactResizeDetector handleWidth={true}>
            {({ width }) => {
                let cname = "";
                let sizeClass: ResponsiveSizeClass | undefined;
                width = width ?? 0;
                if (width > 400) {
                    cname += `${prefix}-sm `;
                    sizeClass = "sm";
                }
                if (width > 640) {
                    cname += `${prefix}-md `;
                    sizeClass = "md";
                }
                if (width > 768 && (maxSize === "2xl" || maxSize === "xl" || maxSize === "lg")) {
                    cname += `${prefix}-lg `;
                    sizeClass = "lg";
                }
                if (width > 1024 && (maxSize === "2xl" || maxSize === "xl")) {
                    cname += `${prefix}-xl `;
                    sizeClass = "xl";
                }
                if (width > 1280 && maxSize === "2xl") {
                    cname += `${prefix}-2xl `;
                    sizeClass = "2xl";
                }
                return (
                    <div id={p.id} className={classNames(cname, p.className, `max-size-${maxSize}`)}>
                        <ResponsiveSizeContext.Provider value={sizeClass}>{p.children}</ResponsiveSizeContext.Provider>
                    </div>
                );
            }}
        </ReactResizeDetector>
    );
};

const ResponsiveSizeContext = React.createContext<ResponsiveSizeClass | undefined>(undefined);

export function useResponsiveSizeClass(): ResponsiveSizeClass | undefined {
    return React.useContext(ResponsiveSizeContext);
}
